import styled from 'styled-components';
import { Text14Bold, Text14Regular, Text16Bold } from '../utils/Text/Text.styles';
import Image from '../utils/Image/Image';

export const Container = styled.div`
  display: grid;
  grid-template-columns: ${({ $gridView }) => ($gridView ? '1fr 1fr' : '1fr')};
  gap: 0.4rem;
  padding: 1.2rem 1.8rem;

  @media (min-width: 761px) {
    grid-template-columns: ${({ $gridView }) => ($gridView ? 'repeat(4, minmax(0, 1fr))' : 'repeat(2, minmax(0, 1fr))')};
    gap: 0.8rem;
    padding: 1.6rem 0;
  }
`;

export const ItemContainer = styled.div`
  height: 27.6rem;
  border-radius: 12px;
  overflow: hidden;
  position: relative;
  cursor: pointer;

  @media (min-width: 761px) {
    height: 24rem;
  }
`;

export const ItemContainerGrid = styled.div`
  overflow: hidden;
  position: relative;
  cursor: pointer;
  border-radius: 12px;
  border: 1px solid #2d2d32;
  background: #18181a;
`;

export const StyledImage = styled(Image)`
  aspect-ratio: unset;
  height: 100%;
  img {
    object-fit: cover;
  }
`;

export const StyledImageGrid = styled(Image)`
  img {
    object-fit: cover;
  }
`;

export const NameWrapper = styled.div`
  border-radius: 32.372px;
  background: rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(2.8563828468322754px);
  height: 3.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 1.2rem;
  position: absolute;
  bottom: 0.6rem;
  left: 0.6rem;
`;

export const NameWrapperGrid = styled.div`
  border-radius: 0 0 12px 12px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%);
  padding: 1.2rem;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
`;

export const NameText = styled(Text14Bold)`
  white-space: nowrap;
`;

export const NameTextGrid = styled(Text16Bold)`
  white-space: nowrap;
  line-height: 2.2rem;
  letter-spacing: -0.408px;
`;

export const RowGrid = styled.div`
  display: flex;
  align-items: center;
  gap: 0.2rem;
`;

export const Blur = styled.div`
  background: linear-gradient(181deg, rgba(0, 0, 0, 0) 57.84%, rgba(0, 0, 0, 0.4) 99.4%);
  position: absolute;
  inset: 0;
`;

export const InfiniteScrollMarker = styled.div`
  width: 1rem;
`;

export const LoaderMoreContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const TelegramText = styled(Text14Regular)`
  line-height: 2.2rem;
  letter-spacing: -0.41px;
  opacity: 0.67;
`;

export const TelegramUsernameText = styled(Text14Bold)`
  line-height: 2.2rem;
  letter-spacing: -0.41px;
  color: #5badff;
`;

export const FilterContainer = styled.div`
  padding: 0 1.8rem;
  display: flex;
  gap: 0.4rem;
  width: 100%;
  overflow: auto;

  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;

  @media (min-width: 761px) {
    padding: 0;
  }
`;

export const FilterButton = styled.button`
  border-radius: 1000px;
  background: ${({ $selected }) => ($selected ? '#fff' : '#313134')};
  padding: 0 1.2rem;
  height: 3.6rem;
  display: flex;
  align-items: center;
  border: ${({ $selected }) => `1px solid ${$selected ? '#fff' : '#313134'}`};
  outline: none;
  color: ${({ $selected }) => (!$selected ? '#fff' : '#313134')};
  font-size: 1.4rem;
  font-weight: 600;
  white-space: nowrap;
  line-height: 2rem;
`;
